import * as _three2 from "three";
var _three = _three2;
try {
  if ("default" in _three2) _three = _three2.default;
} catch (e) {}
import * as _viewerShared2 from "@shapediver/viewer.shared.types";
var _viewerShared = _viewerShared2;
try {
  if ("default" in _viewerShared2) _viewerShared = _viewerShared2.default;
} catch (e) {}
import _FontLoader from "../three/loaders/FontLoader";
import _font from "../three/font";
import * as _viewerShared4 from "@shapediver/viewer.shared.node-tree";
var _viewerShared3 = _viewerShared4;
try {
  if ("default" in _viewerShared4) _viewerShared3 = _viewerShared4.default;
} catch (e) {}
import * as _viewerShared6 from "@shapediver/viewer.shared.services";
var _viewerShared5 = _viewerShared6;
try {
  if ("default" in _viewerShared6) _viewerShared5 = _viewerShared6.default;
} catch (e) {}
import _TextGeometry from "../three/geometries/TextGeometry";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = exports && exports.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __classPrivateFieldGet = exports && exports.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Tag3dGeometryCreationInjector_stateEngine;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag3dGeometryCreationInjector = void 0;
const THREE = __importStar(_three);
const viewer_shared_types_1 = _viewerShared;
const FontLoader_1 = _FontLoader;
const font_1 = _font;
const viewer_shared_node_tree_1 = _viewerShared3;
const viewer_shared_services_1 = _viewerShared5;
const TextGeometry_1 = _TextGeometry;
class Tag3dGeometryCreationInjector {
  // #endregion Properties (2)
  // #region Constructors (1)
  constructor() {
    // #region Properties (2)
    _Tag3dGeometryCreationInjector_stateEngine.set(this, viewer_shared_services_1.StateEngine.instance);
    this._font = new FontLoader_1.Font(font_1.font);
    __classPrivateFieldGet(this, _Tag3dGeometryCreationInjector_stateEngine, "f").fontLoaded.resolve(true);
  }
  // #endregion Constructors (1)
  // #region Public Methods (1)
  convertTag3dToGeometry(tag3dInfo) {
    const node = new viewer_shared_node_tree_1.TreeNode("tag3d_" + tag3dInfo.version);
    tag3dInfo.size = tag3dInfo.size ? +tag3dInfo.size : 1;
    if (tag3dInfo.text === undefined || tag3dInfo.text === "" || /^[ \t\n\r]*$/.test(tag3dInfo.text)) return;
    const tagLines = tag3dInfo.text.split(/\r\n|\r|\n/g);
    const lineArray = [];
    for (let lineIndex = 0; lineIndex < tagLines.length; ++lineIndex) {
      if (tagLines[lineIndex] === "") continue;
      // create tag mesh object
      const tag = new TextGeometry_1.TextGeometry(tagLines[lineIndex], {
        size: tag3dInfo.size,
        height: tag3dInfo.size / 10,
        font: this._font
      });
      lineArray.push(tag);
    }
    // create temporary object
    const parentObject = new THREE.Object3D();
    for (const line of lineArray) {
      parentObject.add(new THREE.Mesh(line, new THREE.MeshPhongMaterial()));
    }
    // align lines
    let bb,
      tempExtentsY,
      lineHeight = 0;
    {
      lineHeight = 0;
      for (const child of parentObject.children) {
        bb = new THREE.Box3().setFromObject(child);
        tempExtentsY = bb.max.y - bb.min.y;
        lineHeight = Math.max(lineHeight, tempExtentsY);
      }
    }
    lineHeight *= 1.15;
    lineArray.forEach((line, i) => {
      line.translate(0, (-i - 1) * lineHeight, 0);
    });
    // justification
    bb = new THREE.Box3().setFromObject(parentObject);
    const extentsX = bb.max.x - bb.min.x;
    const extentsY = bb.max.y - bb.min.y;
    const tagJustTranslation = new THREE.Vector3(0, 0, 0);
    switch (tag3dInfo.justification) {
      case "TL":
        break;
      case "TC":
        tagJustTranslation.x = -extentsX * 0.5;
        break;
      case "TR":
        tagJustTranslation.x = -extentsX;
        break;
      case "ML":
        tagJustTranslation.y = extentsY * 0.5;
        break;
      case "MC":
        tagJustTranslation.x = -extentsX * 0.5;
        tagJustTranslation.y = extentsY * 0.5;
        break;
      case "MR":
        tagJustTranslation.x = -extentsX;
        tagJustTranslation.y = extentsY * 0.5;
        break;
      case "BL":
        tagJustTranslation.y = extentsY;
        break;
      case "BC":
        tagJustTranslation.x = -extentsX * 0.5;
        tagJustTranslation.y = extentsY;
        break;
      case "BR":
        tagJustTranslation.x = -extentsX;
        tagJustTranslation.y = extentsY;
        break;
    }
    for (const line of lineArray) {
      line.translate(tagJustTranslation.x, tagJustTranslation.y, tagJustTranslation.z);
    }
    // rotation
    if (tag3dInfo.location.xAxis !== undefined) {
      const rotMatrix = new THREE.Matrix4();
      rotMatrix.set(tag3dInfo.location.xAxis.X, tag3dInfo.location.yAxis.X, tag3dInfo.location.normal.X, 0, tag3dInfo.location.xAxis.Y, tag3dInfo.location.yAxis.Y, tag3dInfo.location.normal.Y, 0, tag3dInfo.location.xAxis.Z, tag3dInfo.location.yAxis.Z, tag3dInfo.location.normal.Z, 0, 0, 0, 0, 1);
      for (const line of lineArray) {
        line.applyMatrix4(rotMatrix);
        line.translate(tag3dInfo.location.origin.X, tag3dInfo.location.origin.Y, tag3dInfo.location.origin.Z);
      }
    }
    for (const line of lineArray) {
      const attributes = {};
      for (const attribute in line.attributes) {
        let attributeName = attribute.toUpperCase();
        if (/\d/.test(attributeName) && !attributeName.includes("_")) {
          const index = attributeName.search(/\d/);
          attributeName = attributeName.substring(0, index) + "_" + attributeName.substring(index, attributeName.length);
        } else if (attributeName === "TEXCOORD" || attributeName === "COLOR" || attributeName === "JOINTS" || attributeName === "WEIGHTS") {
          attributeName += "_0";
        } else if (attributeName === "UV") {
          attributeName = "TEXCOORD_0";
        }
        attributes[attributeName] = new viewer_shared_types_1.AttributeData(line.attributes[attribute].array, line.attributes[attribute].itemSize, 0, 0, 0, false, line.attributes[attribute].array.length / line.attributes[attribute].itemSize);
      }
      const child = new viewer_shared_node_tree_1.TreeNode("tag3d_" + line);
      child.data.push(new viewer_shared_types_1.GeometryData(new viewer_shared_types_1.PrimitiveData(attributes, null), viewer_shared_types_1.PRIMITIVE_MODE.TRIANGLES, new viewer_shared_types_1.MaterialStandardData({
        color: tag3dInfo.color,
        metalness: 0,
        roughness: 1
      })));
      node.children.push(child);
    }
    return node;
  }
}
exports.Tag3dGeometryCreationInjector = Tag3dGeometryCreationInjector;
_Tag3dGeometryCreationInjector_stateEngine = new WeakMap();
//# sourceMappingURL=Tag3dGeometryCreationInjector.js.map
export default exports;